export default __webpack_public_path__ + "static/media/check-out-review-1.fcf43181.jpg";